// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 486) return "static/chunks/486-f89793879cc1f399.js";
	if (chunkId === 5663) return "static/chunks/5663-8d2018765e7c5f5c.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6054 ? "d3396cfd" : chunkId) + "." + {"923":"c1f86c85b59e594b","1125":"542f74785fec1f6d","2411":"c7b02500a16a7f42","4781":"c06ef2955c65df50","6054":"c28e45c184fb53ad","8728":"bbeb6152f6c39642"}[chunkId] + ".js";
};